import * as React from 'react';
import { SVGProps } from 'react';

const LightBulb = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" {...props}>
    <path
      fill="currentColor"
      d="M17.6 4.8a1.6 1.6 0 1 0-3.2 0v1.6a1.6 1.6 0 0 0 3.2 0V4.8ZM25.05 9.212a1.6 1.6 0 1 0-2.263-2.263l-1.131 1.132a1.6 1.6 0 0 0 2.263 2.262l1.131-1.131ZM28.8 16a1.6 1.6 0 0 1-1.6 1.6h-1.6a1.6 1.6 0 0 1 0-3.2h1.6a1.6 1.6 0 0 1 1.6 1.6ZM8.08 10.343a1.6 1.6 0 0 0 2.262-2.262L9.211 6.949a1.6 1.6 0 1 0-2.263 2.263l1.132 1.131ZM8 16a1.6 1.6 0 0 1-1.6 1.6H4.8a1.6 1.6 0 0 1 0-3.2h1.6A1.6 1.6 0 0 1 8 16ZM12.8 25.6V24h6.4v1.6a3.2 3.2 0 0 1-6.4 0ZM19.2 22.4c.024-.544.331-1.034.762-1.374a6.4 6.4 0 1 0-7.926 0c.431.34.738.83.762 1.374H19.2Z"
    />
  </svg>
);
export default LightBulb;
